export enum OrganisationCardIds {
  OrganisationHeader = "organisationHeader",
  OrganisationLocation = "organisationLocation",
  OrganisationPeople = "organisationPeople",
  OrganisationProfile = "organisationProfile",
  OrganisationType = "organisationType",
  OrganisationAccount = "organisationAccount"
}
